export default __webpack_public_path__ + "static/media/omotola_profPic.ada091ac.webp";